<!-- ============================================================== -->
<!-- Page wrapper  -->
<!-- ============================================================== -->
<div class="page-wrapper" style="color: #8d97ad" >
  <!--[style.margin-top.px]="((layoutManager.mobileMode)?0:60) + ((!layoutManager.mobileMode && layoutManager.innerWidth<1389)?100:0)"-->

  <!-- ============================================================== -->
  <!-- Static Slider 10  -->
  <!-- ============================================================== -->
  <div class="banner-innerpage" style="background-image:url('../../assets/images/banner-bg2.jpg')">
    <div class="container">
      <!-- Row  -->
      <div class="row justify-content-center ">
        <!-- Column -->
        <div class="col-md-6 align-self-center text-center" data-aos="fade-down" data-aos-duration="1200">
          <h1 class="title">Contattaci</h1>
          <h6 class="subtitle op-8">Per informazioni, curiosità o problemi non esitare a contattarci!</h6> </div>
        <!-- Column -->
      </div>
    </div>
  </div>

  <!-- Container fluid  -->
  <!-- ============================================================== -->
  <div class="container-fluid">
    <!-- ============================================================== -->
    <!-- Contact 3  -->
    <!-- ============================================================== -->
    <div class="contact3 spacer">
      <div class="row">
        <div class="col-md-12">
          <div class="container">
            <div class="row m-0">
              <div class="col-lg-7">
                <div class="card-shadow" data-aos="flip-left" data-aos-duration="1200"
                style="margin-top: 20px">
                  <img src="../../../assets/images/call.jpg" alt="assetx" class="img-responsive img-rounded"> </div>
              </div>
              <div class="col-lg-5">
                <div class="contact-box m-l-30">
                  <h1 class="title font-light m-t-10">Contattaci</h1>
                  <form class="m-t-30" data-aos="fade-left" data-aos-duration="1200" *ngIf="!sent">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="form-group m-t-10">
                          <input class="form-control" type="text" placeholder="Nome" #nameInput> </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group m-t-10">
                          <input class="form-control" type="email" placeholder="Indirizzo Email" #emailInput> </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group m-t-10">
                          <input class="form-control" type="text" placeholder="Telefono" #telInput> </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group m-t-10">
                          <textarea class="form-control" rows="3" placeholder="Mesaggio" #messageInput></textarea>
                        </div>
                      </div>
                      <div *ngIf="errorInput" style="margin-left: 10px">
                        <p class="text-danger">Ricontrolla i dati inseriti prima di poter inviare un messaggio</p>
                      </div>
                      <div class="col-lg-12">
                        <button type="submit" class="btn btn-info-gradiant btn-md m-t-20 btn-arrow" [disabled]="loading"
                          (click)="inviaMessaggio(nameInput, emailInput, telInput, messageInput)">
                          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                          <span> INVIA <i class="ti-arrow-right"></i></span></button>
                      </div>
                    </div>
                  </form>
                  <div *ngIf="sent">
                    <p>Grazie per il messagio, verrai contattato per email al più presto!</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="card m-t-40">
                  <div class="row">
                    <div class="col-lg-4 col-md-4">
                      <div class="card-body d-flex no-block c-detail p-l-0">
                        <div class="m-r-20 align-self-center">
                          <img src="../../../assets/images/icon1.png">
                        </div>
                        <div class="">
                          <h6 class="font-medium">Address</h6>
                          <p class="">Conegliano, TV
                            <br> Italia</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4">
                      <div class="card-body d-flex no-block c-detail">
                        <div class="m-r-20 align-self-center">
                          <img src="../../../assets/images/icon2.png">
                        </div>
                        <div class="">
                          <h6 class="font-medium">Phone</h6>
                          <p class="">+39 351 700 2031</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4">
                      <div class="card-body d-flex no-block c-detail">
                        <div class="m-r-20 align-self-center">
                          <img src="../../../assets/images/icon3.png">
                        </div>
                        <div class="">
                          <h6 class="font-medium">Email</h6>
                          <p class="">info@assetcopier.com</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Contact 3  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- End Call to action -->
    <!-- ============================================================== -->
  </div>


</div>

<script type="application/javascript">
  var TxtType = function(el, toRotate, period) {
    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period, 10) || 2000;
    this.txt = '';
    this.tick();
    this.isDeleting = false;
  };

  TxtType.prototype.tick = function() {
    var i = this.loopNum % this.toRotate.length;
    var fullTxt = this.toRotate[i];

    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

    var that = this;
    var delta = 200 - Math.random() * 100;

    if (this.isDeleting) { delta /= 2; }

    if (!this.isDeleting && this.txt === fullTxt) {
      delta = this.period;
      this.isDeleting = true;
    } else if (this.isDeleting && this.txt === '') {
      this.isDeleting = false;
      this.loopNum++;
      delta = 500;
    }

    setTimeout(function() {
      that.tick();
    }, delta);
  };

  window.onload = function() {
    var elements = document.getElementsByClassName('typewrite');
    console.log(elements)
    console.log('test')
    for (var i=0; i<elements.length; i++) {
      var toRotate = elements[i].getAttribute('data-type');
      var period = elements[i].getAttribute('data-period');
      if (toRotate) {
        new TxtType(elements[i], JSON.parse(toRotate), period);
      }
    }
    // INJECT CSS
    var css = document.createElement("style");
    css.type = "text/css";
    css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid transparent}";
    document.body.appendChild(css);
  };
</script>
